import { qs } from '../lib/dom.js';

const metin = qs<HTMLPreElement>('#promptMetni');
const dugme = qs<HTMLButtonElement>('#promptKopyala');
const durum = qs<HTMLSpanElement>('#promptDurum');

dugme.addEventListener('click', async () => {
  try {
    await navigator.clipboard.writeText(metin.textContent ?? '');
    durum.textContent = 'Kopyalandı. Yapay zeka asistanınıza yapıştırın.';
  } catch {
    // Pano izni yoksa (bazı tarayıcılar, http bağlantı) metni seçili bırakmak yeterli.
    getSelection()?.selectAllChildren(metin);
    durum.textContent = 'Kopyalanamadı; metin seçildi, Ctrl+C ile kopyalayabilirsiniz.';
  }
});

// Derleme tarihi yalnızca üretim çıktısında üretilir; `vite dev` sırasında dosya yoktur.
void (async () => {
  try {
    const res = await fetch('/kanit.json');
    if (!res.ok) return;
    const m = (await res.json()) as { derleme?: string };
    if (!m.derleme) return;
    qs<HTMLSpanElement>('#surumBilgisi').textContent =
      `Bu sayfadaki bilgiler ${new Date(m.derleme).toLocaleDateString('tr-TR')} tarihli derlemeden üretildi.`;
  } catch {
    // Tarih gösterilemezse sayfanın geri kalanı çalışmaya devam eder.
  }
})();
